import { colors } from "../../../styles/colors"

const searchBar: any = {
    width: "35%",
    position: "relative",
    display: "inline-flex"
}

const searchIcon: any = {
    position: "absolute",
    right: 13,
    top: 10,
    cursor: "pointer"
}

const searchInput: any = {
    width: "100%",
    borderRadius: 18,
    background: colors.white,
    padding: "0px 40px 0 15px",
    border: "1px solid rgb(210, 210, 210)",
    outline: "none",

    "::placeholder": {
        fontSize: 12,
        fontStyle: "italic"
    }
}

export {
    searchBar,
    searchIcon,
    searchInput
}